import {makeStyles} from '@material-ui/core/styles'
import {Placemark} from '@yandex-taxi/react-ymaps'
import {Props as PlacemarkProps} from '@yandex-taxi/react-ymaps/build/main/components/placemark'
import clsx from 'clsx'
import React from 'react'

import {Grid} from '../../../grid'
import {PinIcon} from '../../icons'

type Props = PlacemarkProps & {
  index: number
  draggable?: boolean
  balloonContent?: string
}

const useClasses = makeStyles(theme => ({
  icon: {
    fill: 'currentColor',
    marginTop: -78,
    marginLeft: -30,
  },
  icon_red: {
    color: '#FB482D',
  },
  icon_black: {
    color: '#21201F',
  },
  placemark: {
    width: 100,
    height: 100,
  },
  balloon: {
    backgroundColor: '#fff',
    borderRadius: 12,
    minWidth: 132,
    position: 'absolute',
    bottom: 'calc(100% + 72px)',
    left: -66,
    padding: '8px 10px',
    boxShadow: theme.go.schemes.effects.bottomShadow,
    fontSize: 13,
    lineHeight: '14px',
    textAlign: 'center',

    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -15,
      left: 'calc(50% - 10px)',
      border: '10px solid transparent',
      borderTop: '10px solid #fff',
    },
  },
}))

const options = {
  iconShape: {
    type: 'Rectangle',
    coordinates: [
      [-30, -39],
      [30, 39],
    ],
  },
  draggable: true,
}

const PointPlacemark: React.FC<Props> = ({index, draggable, balloonContent, ...props}) => {
  const color: 'red' | 'black' = index === 0 ? 'red' : 'black'
  const classes = useClasses()
  const mod = `icon_${color}`
  const className = clsx(classes.icon, {
    [classes[mod]]: true,
  })

  return (
    <Placemark {...props} options={draggable ? options : undefined}>
      {balloonContent && (
        <Grid alignItems="center" className={classes.balloon} justify="center" container>
          <Grid item>{balloonContent}</Grid>
        </Grid>
      )}
      <PinIcon className={className} />
    </Placemark>
  )
}

export default PointPlacemark
